import { useMemo } from 'react';
import { useSettings } from '@/components/settings/lib/settings-context';
import { useCanAccess } from '@/components/authnz/AbilityContext';
import { HELP_ENTRIES } from './help-registry.generated';
import { helpEntriesForPath, visibleHelpEntries } from './help-routes';
import type { HelpEntry } from './help-types';

/** Every Help entry the signed-in viewer may see (Experimental and Admin gating applied). */
export function useHelpEntries(): HelpEntry[] {
  const { settings } = useSettings();
  // Same Access decision that guards the admin pages (/admin/users, /admin/statistics).
  const isAdmin = useCanAccess('manage', 'RoleManagement');
  const experimentalFeaturesEnabled = settings.experimentalFeaturesEnabled === true;
  return useMemo(
    () => visibleHelpEntries(HELP_ENTRIES, { experimentalFeaturesEnabled, isAdmin }),
    [experimentalFeaturesEnabled, isAdmin],
  );
}

/** The Help entries for the screen at `pathname`. */
export function useHelpForPath(pathname: string): HelpEntry[] {
  const entries = useHelpEntries();
  return useMemo(() => helpEntriesForPath(entries, pathname), [entries, pathname]);
}
